import { render } from "./EditProduct.vue?vue&type=template&id=fcc5de50&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=fcc5de50&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=fcc5de50&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcc5de50"]])

export default __exports__